module.exports = __webpack_public_path__ + "static/b-cardiopatia-697c771b749bfab4dd0dd820fd2e91eb.jpg";